// @flow
import React, { Fragment, useContext, useState } from 'react';
import { ReactPageContext } from 'Context/pageContext';
import ReactResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { detect } from 'detect-browser';

import config from 'Config';
import { Chatbot } from './Chatbot';

const CHATBOT_AVATAR_PATH = '/medias/gentil-bot.svg';
const { enabled: chatbotEnabled, enabledPages: chatbotPages } = config.get('botfuel');
const chatBotStyle = {
  backgroundImage: `url("${CHATBOT_AVATAR_PATH}")`,
  bottom: '20px',
  boxShadow: '0 2px 5px 0 rgba(0,0,0,.25)',
  cursor: 'pointer',
  height: '65px',
  right: '20px',
  width: '65px',
  zIndex: '6',
};

function isCompatibleWithChatbot() {
  const browser = detect();
  return browser.name !== 'ie' && browser.name !== 'edge';
}

export const ChatbotContainer = () => {
  const [loadChatbot, setLoadChatbot] = useState(false);
  const [showFakeChatbotBtn, setShowFakeChatbotBtn] = useState(true);
  const responsiveContext = useContext(ReactResponsiveContext);
  const pageContext = useContext(ReactPageContext);
  if (!responsiveContext.isAppMounted || !isCompatibleWithChatbot()) {
    return null;
  }

  // Livechat Dydu "do you dream up" could be inecjected by GTM
  const activeOnThisPage: boolean = chatbotPages.split(',').includes(pageContext.pageType);
  const isDyduLivechatActive =
    document.getElementById('dydu-popin') || document.getElementById('dydu-teaser');

  const chatbotDiv = document.getElementById('botfuel');

  if (chatbotEnabled && activeOnThisPage && !isDyduLivechatActive) {
    if (chatbotDiv) {
      chatbotDiv.style && (chatbotDiv.style.display = 'block');
      return null;
    }

    return (
      <Fragment>
        {loadChatbot && <Chatbot setShowFakeBtn={setShowFakeChatbotBtn} />}
        {showFakeChatbotBtn && (
          <div
            className="rounded-full fixed"
            style={chatBotStyle}
            data-testid="chatbot-button"
            onClick={() => setLoadChatbot(true)}
          />
        )}
      </Fragment>
    );
  }

  chatbotDiv && chatbotDiv.style && (chatbotDiv.style.display = 'none');
  return null;
};
